// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pin-bottom[data-v-3aea5a51],.pin-top[data-v-3aea5a51]{position:relative}.pinned[data-v-3aea5a51]{position:fixed!important}.pushpin-wrapper[data-v-3aea5a51]{margin-top:64px}", ""]);
// Exports
module.exports = exports;
